import { useTranslations } from '@vocab/react';
import { Dropdown } from 'braid-design-system';
import type React from 'react';

import translations from '@seek/rr-caja/src/.vocab';

import {
  CustomQuestionType,
  type DraftCustomQuestion,
} from '../DraftCustomQuestion/DraftCustomQuestion';

interface CustomQuestionAnswerListProps {
  question: DraftCustomQuestion;
  onChange: (question: Partial<DraftCustomQuestion>) => void;
}

const CustomQuestionAnswerList: React.FunctionComponent<
  CustomQuestionAnswerListProps
> = ({ question, onChange }) => {
  const { t } = useTranslations(translations);

  return (
    <Dropdown
      id={String(question.position)}
      label={t('custom.answerTypeDropdown.label')}
      aria-label={t('custom.answerTypeDropdown.label')}
      onChange={(event) => {
        onChange({
          type: event.currentTarget.value as CustomQuestionType,
          options: pickAnswers(event.currentTarget.value as CustomQuestionType),
        });
      }}
      value={question.type}
    >
      <option value={CustomQuestionType.FreeText}>
        {t('custom.answerType.freeText')}
      </option>
      <option value={CustomQuestionType.YesNo}>
        {t('custom.answerType.yesNo')}
      </option>
      <option value={CustomQuestionType.MultipleChoice}>
        {t('custom.answerType.multipleChoice')}
      </option>
    </Dropdown>
  );
};

const pickAnswers = (newOption: CustomQuestionType): string[] => {
  if (newOption === CustomQuestionType.YesNo) {
    return ['Yes', 'No'];
  }

  if (newOption === CustomQuestionType.MultipleChoice) {
    return ['', ''];
  }

  return [];
};

export default CustomQuestionAnswerList;
